// Merges the per-category authored content into one lookup keyed by template id.
export type { TemplateSpecific } from "./types";

import type { TemplateSpecific } from "./types";
import { WORK_AT_HEIGHT } from "./workAtHeight";
import { ELECTRICAL } from "./electrical";
import { GROUNDWORKS } from "./groundworks";
import { LIFTING_PLANT } from "./liftingPlant";
import { HOT_WORKS } from "./hotWorks";
import { COSHH_SUBSTANCES } from "./coshhSubstances";
import { DEMOLITION_STRIP } from "./demolitionStrip";
import { TRADES_FINISHING } from "./tradesFinishing";
import { SITE_GENERAL } from "./siteGeneral";

export const TEMPLATE_SPECIFIC: Record<string, TemplateSpecific> = {
  ...WORK_AT_HEIGHT,
  ...ELECTRICAL,
  ...GROUNDWORKS,
  ...LIFTING_PLANT,
  ...HOT_WORKS,
  ...COSHH_SUBSTANCES,
  ...DEMOLITION_STRIP,
  ...TRADES_FINISHING,
  ...SITE_GENERAL,
};
